'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mautic = require('../actions/mautic');

var defaultState = { segments: [] };

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];


    switch (action.type) {
        case _mautic.actionTypes.FETCH_MAUTIC_SEGMENTS_SUCCEEDED:
            return _extends({}, state, {
                segments: action.segments
            });
        default:
            return state;
    }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvcmVkdWNlcnMvbWF1dGljLmpzIl0sIm5hbWVzIjpbImRlZmF1bHRTdGF0ZSIsInNlZ21lbnRzIiwic3RhdGUiLCJhY3Rpb24iLCJ0eXBlIiwiYWN0aW9uVHlwZXMiLCJGRVRDSF9NQVVUSUNfU0VHTUVOVFNfU1VDQ0VFREVEIl0sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUFBOztBQUVBLElBQU1BLGVBQWUsRUFBRUMsVUFBVSxFQUFaLEVBQXJCOztrQkFFZSxZQUFrQztBQUFBLFFBQWpDQyxLQUFpQyx1RUFBekJGLFlBQXlCO0FBQUEsUUFBWEcsTUFBVzs7O0FBRTdDLFlBQVFBLE9BQU9DLElBQWY7QUFDSSxhQUFLQyxvQkFBWUMsK0JBQWpCO0FBQ0ksZ0NBQ09KLEtBRFA7QUFFSUQsMEJBQVVFLE9BQU9GO0FBRnJCO0FBSUo7QUFDSSxtQkFBT0MsS0FBUDtBQVBSO0FBU0gsQyIsImZpbGUiOiJtYXV0aWMuanMiLCJzb3VyY2VSb290IjoiL3NyYyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGFjdGlvblR5cGVzIH0gZnJvbSAnLi4vYWN0aW9ucy9tYXV0aWMnO1xuXG5jb25zdCBkZWZhdWx0U3RhdGUgPSB7IHNlZ21lbnRzOiBbXSB9O1xuXG5leHBvcnQgZGVmYXVsdCAoc3RhdGUgPSBkZWZhdWx0U3RhdGUsIGFjdGlvbikgPT4ge1xuXG4gICAgc3dpdGNoIChhY3Rpb24udHlwZSkge1xuICAgICAgICBjYXNlIGFjdGlvblR5cGVzLkZFVENIX01BVVRJQ19TRUdNRU5UU19TVUNDRUVERUQ6XG4gICAgICAgICAgICByZXR1cm4ge1xuICAgICAgICAgICAgICAgIC4uLnN0YXRlLFxuICAgICAgICAgICAgICAgIHNlZ21lbnRzOiBhY3Rpb24uc2VnbWVudHNcbiAgICAgICAgICAgIH07XG4gICAgICAgIGRlZmF1bHQ6XG4gICAgICAgICAgICByZXR1cm4gc3RhdGU7XG4gICAgfVxufTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./src/client/reducers/mautic.js
// module id = 2272
// module chunks = 0